import { atom } from 'recoil';

export const PlatformVoucherAtom = atom({
  key: 'platformVoucherAtom',
  default: []
})

export const ProductVoucherAtom = atom({
  key: "productVoucherAtom",
  default: []
})